module.exports = __webpack_public_path__ + "img/logo_insurance.7d8d5110.svg";